import { render, staticRenderFns } from "./OurGoodness.vue?vue&type=template&id=1e2854c5&scoped=true&"
var script = {}
import style0 from "./OurGoodness.vue?vue&type=style&index=0&id=1e2854c5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2854c5",
  null
  
)

export default component.exports